import { useLight } from "@/context/LightContext";
import { useEffect, useState } from "react";

/**
 * Fixed ambient warm-gold radial glow that persists behind ALL content
 * once the visitor has scrolled past the top of the fold. Sits at
 * z-index 0 — behind everything, visible through the transparent parts
 * of section backgrounds. It's a continuation of the Hero spotlight's
 * bloom, so the same gold family is used.
 */
export default function AmbientGlow() {
    const { activated } = useLight();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!activated) {
            setVisible(false);
            return;
        }
        const onScroll = () => {
            const y = window.scrollY;
            const vh = window.innerHeight;
            setVisible(y > vh * 0.5);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [activated]);

    return (
        <div
            aria-hidden="true"
            data-testid="ambient-glow"
            className="ambient-glow-layer"
            style={{
                position: "fixed",
                inset: 0,
                pointerEvents: "none",
                zIndex: 0,
                opacity: visible ? 1 : 0,
                transition: "opacity 1.2s ease-out",
                willChange: "transform",
                background:
                    "radial-gradient(ellipse 1400px 900px at 50% 78%, rgba(255,220,138,0.14) 0%, rgba(212,175,55,0.08) 22%, rgba(139,10,10,0.05) 45%, rgba(0,0,0,0) 72%)",
            }}
        />
    );
}
